var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-sub-title',{attrs:{"text":"Respuestas lista de chequeo"}}),_vm._v(" "),_c('app-supervision-checklist-filters',{attrs:{"authors":_vm.authors},on:{"filter":_vm.onFilter}}),_vm._v(" "),_c('app-table-supervision-checklist',{attrs:{"data":_vm.data},on:{"change-page":_vm.onChangePage,"sort":_vm.onSort}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }